import { useEffect } from 'react'
import toast, { ToastBar, Toaster } from 'react-hot-toast'
import { FormattedMessage } from 'react-intl'

export const TOAST_TYPES = {
    wishlistAdded: 'wishlistAdded',
    wishlistRemoved: 'wishlistRemoved',
    cartAdded: 'cartAdded'
}

export const URLS = {
    wishlist: window.Shopify?.routes?.wishlist,
    cart: window.Shopify?.routes?.cart
}

function ToastMessages() {

    /**
     * RENDERING
     */

    const renderToastMessage = (toastObj, message, type) => {
        return <ToastBar toast={toastObj}>
            {() => (
                <>
                    <div className="toast__body" onClick={ () => toast.dismiss(toastObj.id)}>
                        <p className="toast__message">{message}</p>
                    </div>
                    { type === TOAST_TYPES.wishlistAdded && <a className="toast__link" href={URLS.wishlist}>
                        <FormattedMessage defaultMessage="Wunschzettel anzeigen" />
                        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentcolor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.501 5.501 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78Z"/></svg>
                    </a> }
                    { type === TOAST_TYPES.cartAdded && <a className="toast__link" href={URLS.cart}>
                        <FormattedMessage defaultMessage="Warenkorb anzeigen" />
                        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 27"><path fill="currentcolor" fillRule="evenodd" d="M14.06 0c3.72 0 6.788 2.824 7.162 6.432H28V27H0V6.432h6.9C7.272 2.824 10.341 0 14.06 0ZM2.826 22.298c-.721 0-1.305.582-1.305 1.3 0 .718.584 1.3 1.305 1.3.72 0 1.305-.582 1.305-1.3 0-.718-.584-1.3-1.305-1.3Zm5.56 0c-.72 0-1.305.582-1.305 1.3 0 .718.584 1.3 1.305 1.3s1.305-.582 1.305-1.3c0-.718-.584-1.3-1.305-1.3Zm5.56 0c-.72 0-1.305.582-1.305 1.3 0 .718.584 1.3 1.305 1.3s1.306-.582 1.306-1.3c0-.718-.585-1.3-1.306-1.3Zm5.56 0c-.72 0-1.305.582-1.305 1.3 0 .718.584 1.3 1.305 1.3s1.306-.582 1.306-1.3c0-.718-.585-1.3-1.306-1.3Zm5.56 0c-.72 0-1.305.582-1.305 1.3 0 .718.585 1.3 1.306 1.3.72 0 1.305-.582 1.305-1.3 0-.718-.585-1.3-1.305-1.3Zm-19.63-3.422c-.72 0-1.305.582-1.305 1.3 0 .718.585 1.3 1.306 1.3.72 0 1.305-.582 1.305-1.3 0-.718-.585-1.3-1.305-1.3Zm5.825 0c-.72 0-1.305.582-1.305 1.3 0 .718.584 1.3 1.305 1.3.72 0 1.305-.582 1.305-1.3 0-.718-.584-1.3-1.305-1.3Zm5.824 0c-.72 0-1.305.582-1.305 1.3 0 .718.585 1.3 1.305 1.3.721 0 1.306-.582 1.306-1.3 0-.718-.585-1.3-1.306-1.3Zm5.825 0c-.721 0-1.305.582-1.305 1.3 0 .718.584 1.3 1.305 1.3.72 0 1.305-.582 1.305-1.3 0-.718-.584-1.3-1.305-1.3ZM2.826 15.454c-.721 0-1.305.582-1.305 1.3 0 .718.584 1.3 1.305 1.3.72 0 1.305-.582 1.305-1.3 0-.718-.584-1.3-1.305-1.3Zm5.56 0c-.72 0-1.305.582-1.305 1.3 0 .718.584 1.3 1.305 1.3s1.305-.582 1.305-1.3c0-.718-.584-1.3-1.305-1.3Zm5.56 0c-.72 0-1.305.582-1.305 1.3 0 .718.584 1.3 1.305 1.3s1.306-.582 1.306-1.3c0-.718-.585-1.3-1.306-1.3Zm5.56 0c-.72 0-1.305.582-1.305 1.3 0 .718.584 1.3 1.305 1.3s1.306-.582 1.306-1.3c0-.718-.585-1.3-1.306-1.3Zm5.56 0c-.72 0-1.305.582-1.305 1.3 0 .718.585 1.3 1.306 1.3.72 0 1.305-.582 1.305-1.3 0-.718-.585-1.3-1.305-1.3Zm-19.63-3.422c-.72 0-1.305.582-1.305 1.3 0 .718.585 1.3 1.306 1.3.72 0 1.305-.582 1.305-1.3 0-.718-.585-1.3-1.305-1.3Zm5.825 0c-.72 0-1.305.582-1.305 1.3 0 .718.584 1.3 1.305 1.3.72 0 1.305-.582 1.305-1.3 0-.718-.584-1.3-1.305-1.3Zm5.824 0c-.72 0-1.305.582-1.305 1.3 0 .718.585 1.3 1.305 1.3.721 0 1.306-.582 1.306-1.3 0-.718-.585-1.3-1.306-1.3Zm5.825 0c-.721 0-1.305.582-1.305 1.3 0 .718.584 1.3 1.305 1.3.72 0 1.305-.582 1.305-1.3 0-.718-.584-1.3-1.305-1.3ZM2.826 8.61c-.721 0-1.305.582-1.305 1.3 0 .718.584 1.3 1.305 1.3.72 0 1.305-.582 1.305-1.3 0-.718-.584-1.3-1.305-1.3Zm5.56 0c-.72 0-1.305.582-1.305 1.3 0 .718.584 1.3 1.305 1.3s1.305-.582 1.305-1.3c0-.718-.584-1.3-1.305-1.3Zm5.56 0c-.72 0-1.305.582-1.305 1.3 0 .718.584 1.3 1.305 1.3s1.306-.582 1.306-1.3c0-.718-.585-1.3-1.306-1.3Zm5.56 0c-.72 0-1.305.582-1.305 1.3 0 .718.584 1.3 1.305 1.3s1.306-.582 1.306-1.3c0-.718-.585-1.3-1.306-1.3Zm5.56 0c-.72 0-1.305.582-1.305 1.3 0 .718.585 1.3 1.306 1.3.72 0 1.305-.582 1.305-1.3 0-.718-.585-1.3-1.305-1.3ZM14.06 1.435A5.76 5.76 0 0 0 8.35 6.432h11.423a5.76 5.76 0 0 0-5.712-4.997Z" clipRule="evenodd"/></svg>
                    </a> }
                </>
            )}
        </ToastBar>
    }

    /**
     * EVENTS
     */

    useEffect(() => {
        const handleToastEvent = (event) => {
            const { type, message } = event.detail || {}

            toast.custom((toastObject) => renderToastMessage(toastObject, message, type), {
                className: 'toast',
                position: 'top-right',
            })
        }

        window.addEventListener('toast', handleToastEvent)

        return () => window.removeEventListener('toast', handleToastEvent)
    }, [])

    return <>
        <Toaster />
    </>
}

export default ToastMessages